export enum RewardCenterSection {
  'WELCOME' = 'WELCOME',
  'TASKS' = 'TASKS',
}
